var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'main-cover-container': true,
  'fade-out': _vm.PAGE_INDEX !== _vm.currentPage,
},attrs:{"id":"page0"}},[_c('div',{staticClass:"main-cover"},[_c('div',{class:{
        'background-image': true,
        'dark': _vm.coverStep >= 1,
      }}),_c('div',{class:{
        'cover-text-wrapper': true,
        'shining-animation': _vm.coverStep === 0,
        'enlarge': _vm.coverStep === 1,
        'dark': _vm.coverStep === 2,
      }},[_c('TimeText',{attrs:{"coverShakeFlag":_vm.coverStep === 1}})],1),_c('div',{class:{
        'title-wrapper': true,
        'fly-in': _vm.coverStep === 2,
      }},[_c('img',{attrs:{"src":_vm.coverSrc,"alt":"天亮之後 921二十週年"}})])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPage === 0),expression:"currentPage === 0"}],staticClass:"scroll-down-arrow-wrapper"},[_c('ScrollDownArrow')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }